import React, { Fragment } from 'react'

import { PaddingProps } from 'styled-system'

import { Row, Text } from 'Components/UI'

import { HomeGlyph } from 'Assets/Svg/Icons'

import { ROOT } from 'Constants/Paths'

import { StyledLink } from './styles'

type Path = {
  href: string
  caption: string
}

type Props = PaddingProps & {
  paths: Path[]
}

function Breadcrumbs({ paths, ...rest }: Props) {
  return (
    <Row {...rest} alignCenter gap={4}>
      <StyledLink aria-label="Home" href={ROOT}>
        {HomeGlyph()}
      </StyledLink>

      {!!paths.length &&
        paths.map(item => (
          <Fragment key={item.href}>
            <Text as="span" body12 medium muted>
              /
            </Text>

            <StyledLink href={item.href}>
              <Text as="span" body12 medium title>
                {item.caption}
              </Text>
            </StyledLink>
          </Fragment>
        ))}
    </Row>
  )
}

export default Breadcrumbs
